module.exports = new __parcel__URL__("others_receiver_level_1.17466520.png").toString();